import React, { useState } from 'react';
import { BillingData } from '../../hooks/data/useBillingStatus';
import BillingDetailModal from '../../modals/BillingDetailModal';

interface Props {
    billed?: boolean;
    billingInfo?: string;
    billingData?: BillingData | null;
    isPolling?: boolean;
    fetchBillingStatus?: () => Promise<void>;
}

const BillingStatusBadge: React.FC<Props> = ({ billed, billingInfo, billingData, isPolling, fetchBillingStatus }) => {
    const [isModalOpen, setIsModalOpen] = useState(false);

    if (billed === undefined && !billingInfo && !billingData && !isPolling) return null;

    const displayBilled = billingData?.billed ?? billed;
    const displayInfo = billingData?.billing_info || billingInfo;
    const items = billingData?.items || [];

    const handleOpenModal = () => {
        if (displayBilled && fetchBillingStatus) fetchBillingStatus();
        setIsModalOpen(true);
    };

    return (
        <>
            <div className="border border-gray-200 dark:border-slate-600 rounded-lg p-4 mt-4">
                <div className="flex items-center justify-between mb-2">
                    <h3 className="text-md font-semibold text-gray-700 dark:text-gray-200">Status do Faturamento</h3>
                </div>
                <div className="flex items-center gap-4">
                    <div className="flex items-center gap-2">
                        {isPolling && !displayBilled ? (
                            <>
                                <svg className="animate-spin h-3 w-3 text-amber-500" viewBox="0 0 24 24" fill="none">
                                    <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" />
                                    <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z" />
                                </svg>
                                <span className="text-sm text-amber-600 dark:text-amber-400">Enviando para faturamento...</span>
                            </>
                        ) : (
                            <>
                                <span className={`inline-block w-3 h-3 rounded-full ${displayBilled ? 'bg-green-500' : 'bg-gray-400'}`} />
                                <span className="text-sm text-gray-700 dark:text-gray-300">
                                    {displayBilled ? 'Faturado' : 'Não faturado'}
                                </span>
                            </>
                        )}
                    </div>
                    {displayInfo && (
                        <span
                            className="text-sm text-blue-600 dark:text-blue-400 cursor-pointer hover:underline"
                            onClick={handleOpenModal}
                        >
                            {displayInfo}
                        </span>
                    )}
                    {items.length > 0 && !displayInfo && (
                        <button type="button" onClick={handleOpenModal} className="text-xs text-blue-600 dark:text-blue-400 hover:underline">
                            Ver {items.length} título(s)
                        </button>
                    )}
                </div>
            </div>

            <BillingDetailModal
                isOpen={isModalOpen}
                onClose={() => setIsModalOpen(false)}
                items={items}
                billingInfo={displayInfo}
                isProcessing={!displayBilled}
                onRefresh={fetchBillingStatus}
            />
        </>
    );
};

export default BillingStatusBadge;
